export const VENTURE_CATEGORIES = [
  'lead', 'qualified', 'demo_booked', 'demo_completed',
  'closed_won', 'closed_lost', 'unmapped',
] as const;

export type VentureCategory = typeof VENTURE_CATEGORIES[number];

// Funnel order: index 0 is top (widest), higher = deeper in funnel
export const CATEGORY_FUNNEL_ORDER: Record<VentureCategory, number> = {
  lead: 0,
  qualified: 1,
  demo_booked: 2,
  demo_completed: 3,
  closed_won: 4,
  closed_lost: 4,  // Same depth as closed_won (both are terminal)
  unmapped: -1,
};

export const CATEGORY_LABELS: Record<VentureCategory, string> = {
  lead: 'Lead',
  qualified: 'Qualified',
  demo_booked: 'Demo Booked',
  demo_completed: 'Demo Completed',
  closed_won: 'Closed Won',
  closed_lost: 'Closed Lost',
  unmapped: 'Unmapped',
};

export const CATEGORY_COLORS: Record<VentureCategory, string> = {
  lead: 'bg-blue-500/20 text-blue-400',
  qualified: 'bg-amber-500/20 text-amber-400',
  demo_booked: 'bg-purple-500/20 text-purple-400',
  demo_completed: 'bg-teal-500/20 text-teal-400',
  closed_won: 'bg-green-500/20 text-green-400',
  closed_lost: 'bg-red-500/20 text-red-400',
  unmapped: 'bg-gray-500/20 text-gray-400',
};

export const CATEGORY_BADGE_VARIANTS: Record<VentureCategory, 'info' | 'warning' | 'success' | 'error' | 'default'> = {
  lead: 'info',
  qualified: 'warning',
  demo_booked: 'info',
  demo_completed: 'success',
  closed_won: 'success',
  closed_lost: 'error',
  unmapped: 'default',
};

/**
 * Check if a category is "at or deeper than" a target in the funnel.
 * Used for cumulative metrics: e.g., "demo_booked" includes demo_completed, closed_won.
 */
export function isCategoryAtOrDeeper(
  category: VentureCategory,
  target: VentureCategory
): boolean {
  if (category === 'unmapped') return false;
  return CATEGORY_FUNNEL_ORDER[category] >= CATEGORY_FUNNEL_ORDER[target];
}
